import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'duotone-building-svg-icon',
    templateUrl: 'duotone-building-svg-icon.component.html',
    standalone: false
})

export class DuotoneBuildingSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
